import React, { useState, useEffect } from 'react';
import './card.css'

function Card(props) {
    
    const hasDescription=()=>{
        if(props.description !== ''){
            return (<div className='description text-center'><p> {props.description}</p></div>)
        }
    }

    return (
        <div className='card'>
            <img src={props.img} loading='lazy'></img>
            <h2 className='text-center'>{props.name}</h2>
            {hasDescription()}
            <a href={props.linkURL} target="_blank">Mas info.</a>
        </div> 
        
    )
}

export default Card;